
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "the-economist-design-system"
    }}>{`The Economist Design System`}</h1>
    <ul>
      <li parentName="ul">{`NPM module: `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@economist/design-system"
        }}>{`@economist/design-system`}</a></li>
      <li parentName="ul">{`GitHub repository: `}<a parentName="li" {...{
          "href": "https://github.com/EconomistDigitalSolutions/design-system"
        }}>{`EconomistDigitalSolutions/design-system`}</a></li>
    </ul>
    <h2 {...{
      "id": "about-the-documentation"
    }}>{`About the documentation`}</h2>
    <p>{`The Economist Design System uses `}<a parentName="p" {...{
        "href": "https://www.docz.site/"
      }}>{`docz`}</a>{` to generate interactive documentation.`}</p>
    <p>{`This documentation is automatically updated as part of the design system release process.`}</p>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h2>
    <p>{`Run `}<inlineCode parentName="p">{`npm run docs`}</inlineCode>{` to run the interactive documentation and to preview when developing components in the design system.`}</p>
    <p>{`Every component should have a `}<a parentName="p" {...{
        "href": "https://mdxjs.com/"
      }}>{`MDX`}</a>{` file which imports the component, lists defined properties and can be used to describe how and when to use the component.`}</p>
    <pre><code parentName="pre" {...{}}>{`---
name: Button
route: /components-button
edit: false
---

import { Playground, Props } from 'docz'
import Button from './button'

# Button
<Playground>
  <Button type='button'>Click</Button>
</Playground>

## Properties
<Props of={Button} />
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;